import React, { Component, Suspense } from "react";
import { settings } from "../portfolio.js";
import ModernLoader from "../components/Loader/ModernLoader";
import SinglePage from "./SinglePage/SinglePage";

// Lazy load components for better performance
const Splash = React.lazy(() => import("../pages/splash/Splash"));

export default class Main extends Component {
  render() {
    if (settings.isSplash) {
      return (
        <Suspense fallback={<ModernLoader />}>
          <Splash theme={this.props.theme} />
        </Suspense>
      );
    } else {
      return (
        <div style={{ width: "100%", maxWidth: "100vw", margin: "0 auto" }}>
          <SinglePage theme={this.props.theme} />
        </div>
      );
    }
  }
}
